import Dashboard from "../shared/file/dashboard";
import FakeDashboard from "../shared/file/dashboard/dashboardFake/index.fake";

export default function Home() {
  // return <Dashboard />;
  return <FakeDashboard />;
}
